const productsData = [
    {
        id: "edge-ai-processor", // used in URL
        name: "Edge AI Processor",
        items: [
            {
                id: "ctx-edge-ai-processor", // used in URL
                name: "CTX Edge AI Processor"
            }
        ]
    },
    {
        id: "analog-mixed-signal-ips", // used in URL
        name: "Analog Mixed Signal IPs",
        items: [
            {
                id: "phase-locked-loop",
                name: "Phase Locked Loop (PLL)"
            },
            {
                id: "adc",
                name: "Analog-to-Digital Converter (ADC)"
            }
        ]
    }
];

export default productsData;
